import { Directive, HostListener, inject } from '@angular/core';
import { FormControlDirective, FormControlName } from '@angular/forms';

@Directive({
    selector: 'textarea[bigSharedTrimOnBlur], input[bigSharedTrimOnBlur]',
})
export class TrimInputOnBlurDirective {
    private readonly formControlDir = inject(FormControlDirective, { optional: true });
    private readonly formControlName = inject(FormControlName, { optional: true });

    @HostListener('blur')
    public onBlur(): void {
        const control = this.formControlDir?.control ?? this.formControlName?.control;

        if (!control) {
            return;
        }

        const { value } = control;

        if (typeof value !== 'string') {
            return;
        }

        control.patchValue(value.trim());
    }
}
